import { ColorBy } from "@atlas-int/data";
import { psColors } from "./constants";
import { greenColorScale } from "./greenColorScale";

export type ProductSpaceNode = {
  cluster_name_short?: string;
  product_code?: string;
  x?: string;
  y?: string;
};
export type ProductData = {
  productId: string;
  greenProduct?: boolean;
  topParent?: { productId: string };
};

export const getFillColor = (
  node: ProductSpaceNode,
  productData: ProductData,
  topParentId: string,
  colorBySelection: ColorBy,
  colorMap: Map<string, string>,
  clusterColorLookup: Map<string, { cluster_col?: string }>,
  complexityColorScaleFn: (value: number | undefined) => string,
  totalExportLookup: Map<string, { pci?: number }>,
  hiddenCategories: string[],
  countryExportLookup: Map<
    string,
    { exportRca?: number; exportValue?: number }
  >,
  rcaThreshold: number,
) => {
  let fill: string = psColors.nodeDefault;
  let filtered = false;
  let fillColor: string = psColors.nodeDefault;
  if (colorBySelection === ColorBy.Green) {
    fillColor = greenColorScale(
      {
        greenProduct: productData?.greenProduct,
        exportRca: countryExportLookup.get(productData?.productId)?.exportRca,
      },
      rcaThreshold,
    );
    fill = fillColor;
  } else if (colorBySelection === ColorBy.Sector) {
    fillColor = colorMap.get(topParentId) || psColors.nodeDefault;
    fill = fillColor;
  } else if (colorBySelection === ColorBy.Cluster) {
    const clusterName = node?.cluster_name_short;
    const clusterData = clusterName
      ? clusterColorLookup.get(clusterName)
      : null;
    fillColor = clusterData?.cluster_col || psColors.nodeDefault;
    fill = fillColor;
  } else if (colorBySelection === ColorBy.Complexity) {
    fillColor = complexityColorScaleFn(
      totalExportLookup.get(productData?.productId)?.pci,
    );
    fill = fillColor;
  }

  if (
    (colorBySelection === ColorBy.Sector &&
      hiddenCategories.includes(topParentId)) ||
    (colorBySelection === ColorBy.Cluster &&
      node?.cluster_name_short &&
      hiddenCategories.includes(node.cluster_name_short)) ||
    (colorBySelection === ColorBy.Green &&
      hiddenCategories.includes(
        `${productData?.greenProduct ? "green" : "not-green"}-${
          (countryExportLookup.get(productData?.productId)?.exportRca || 0) >
          rcaThreshold
            ? "high"
            : "low"
        }-rca`,
      ))
  ) {
    fill = psColors.nodeMuted;
    filtered = true;
  }

  if (
    colorBySelection !== ColorBy.Green &&
    ((countryExportLookup.get(productData?.productId)?.exportRca || 0) <
      rcaThreshold ||
      !countryExportLookup.get(productData?.productId)?.exportRca) &&
    rcaThreshold !== 0
  ) {
    fill = psColors.nodeInactive;
  }

  return { fill, filtered, fillColor };
};
